export var req_body = {
	promotion_name: "",
	promotion_desc: "",
	is_custom: 1,
	is_previewed: 0,
	promotion_header: {
		en: "",
		es: "",
		vi: "",
	},
	promotion_information: {
		en: "",
		es: "",
		vi: "",
	},
	invite_reminder_list: [
		{
			sms_text: {
				en: "",
				es: "",
				vi: "",
			},
			email_subject: "",
			email_body: "",
			invite_code: "NRSMS",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
		{
			sms_text: "",
			email_subject: {
				en: "",
				es: "",
				vi: "",
			},
			email_body: {
				en: "",
				es: "",
				vi: "",
			},
			invite_code: "NREML",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
		{
			sms_text: {
				en: "",
				es: "",
				vi: "",
			},
			email_subject: "",
			email_body: "",
			invite_code: "FRSMS",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
		{
			sms_text: "",
			email_subject: {
				en: "",
				es: "",
				vi: "",
			},
			email_body: {
				en: "",
				es: "",
				vi: "",
			},
			invite_code: "FREML",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
		{
			sms_text: {
				en: "",
				es: "",
				vi: "",
			},
			email_subject: "",
			email_body: "",
			invite_code: "FNSMS",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
		{
			sms_text: "",
			email_subject: {
				en: "",
				es: "",
				vi: "",
			},
			email_body: {
				en: "",
				es: "",
				vi: "",
			},
			invite_code: "FNEML",
			is_created: 1,
			schedule_date: "1964-05-22 19:30:34",
		},
	],
};


export const initialFlagsPrebuilt = {
	"email_invitation": false,
	"final_reminder_email": false,
	"final_reminder_sms": false,
	"first_reminder_email": false,
	"first_reminder_sms": false,
	"sms_invitation": false,
}

export const initialFlagsGeneric = {
	"email_invitation": false,
	"final_reminder_email": false,
	"final_reminder_sms": false,
	"first_reminder_email": false,
	"first_reminder_sms": false,
	"sms_invitation": false,
}
